import { Button, Dialog } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { financialYear } from './utils';
import { ActionHeader, FaqLink } from '..';
import en from '../../../../lang/en-us';
import { TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { getForm15Info } from '../../../../redux-store/actions/nct';
import { RootStateType } from '../../../../redux-store/reducers';
import { Form15Response } from '../../../../redux-store/types/nct';
import { LIST_PROTFOLIO_PAYLOAD } from '../../../../redux-store/types/portfolio';
import { FORM_15GH } from '../../../../utils/constants';
import NoFoliosFound from '../NoFoliosFound';
import { NFT_TRXN_TYPE_MAP } from '../../commercial/utils';
import { PanSeedCheckNew } from '../../../common/PanSeedCheckNew';
const { dashboard } = en;

const columns: TableColumn[] = [
    {
        headerName: 'PAN',
        field: 'pan',
    },
    {
        headerName: 'Fund House',
        field: 'amcName',
        filterBy: true,
        filterHeader: 'Fund House',
        filterKey: 'amcName',
    },
    {
        headerName: 'REGISTRATION STATUS',
        field: 'regStatus',
    },
    {
        headerName: 'FORM TYPE',
        field: 'docType',
        valueGetter: ({ value }) => `Form ${value}`,
    },
    {
        headerName: 'FIN. YEAR',
        field: 'year',
    },
];

function UpdateForm15List(props: any) {
    const { type } = props.location.state || {};
    const [rowData, setRowData] = useState<Form15Response[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const { tableRows, tableColumns, resetFilters, resetTable, ...rest } = useTableWithCollapse<
        Form15Response[]
    >({ rows: rowData, columns, loading });

    useEffect(() => {
        setLoading(true);
        async function callApi() {
            const payload: LIST_PROTFOLIO_PAYLOAD = {
                pan: props.pan,
                mobile: props.mobile,
                pekrn: props.pekrn,
                reqId: props.reqId,
            };
            try {
                const { body = {} } = await props.getForm15Info(payload);
                const { data = [] }: { data: Form15Response[] } = body;
                const {
                    matched = [],
                    unMatched = [],
                }: { matched: Form15Response[]; unMatched: Form15Response[] } = data.reduce(
                    (prev: any, curr: Form15Response) => {
                        if (type === curr.docType) {
                            if (curr.regStatus === 'Y') {
                                return {
                                    ...prev,
                                    unMatched: [
                                        ...prev.unMatched,
                                        {
                                            ...curr,
                                            id: `${curr.pan} - ${curr.amc}`,
                                            isDisabled: true,
                                            year: financialYear(new Date().getFullYear()),
                                            regStatus: 'Yes',
                                        },
                                    ],
                                };
                            }
                            return {
                                ...prev,
                                matched: [
                                    ...prev.matched,
                                    {
                                        ...curr,
                                        id: `${curr.pan} - ${curr.amc}`,
                                        year: financialYear(new Date().getFullYear()),
                                        regStatus: 'No',
                                    },
                                ],
                            };
                        }
                        return prev;
                    },
                    { matched: [], unMatched: [] },
                );

                setRowData([...matched, ...unMatched]);
                setLoading(false);
            } catch (err: any) {
                alert(err.message);
            }
        }
        callApi();
        return () => {};
    }, []);

    useEffect(() => {
        if (!type) {
            return props.history.push('/');
        }
    });

    const _handleNext = () => {
        props.history.replace('update-form15-income', {
            type,
            targetFunds: rest.selectedRows,
        });
    };

    const [callPanSeed, setCallPanSeed] = useState(false);

    const resetTrigger = () => {
        setCallPanSeed(false);
    }

    return (
        <div className="curved-bg">
            <PanSeedCheckNew
                callBackFn={_handleNext}
                foliosArray={tableRows}
                trxnType={NFT_TRXN_TYPE_MAP.updateForm15}
                triggerCheck={callPanSeed}
                goBack={false}
                resetTrigger={resetTrigger}
            />
            <ActionHeader
                header={
                    type === '15H'
                        ? dashboard.UpdateForm15.UpdateForm15HHeading
                        : dashboard.UpdateForm15.UpdateForm15GHeading
                }
            />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <h5> {dashboard.UpdateForm15.UpdateForm15TableInfo}</h5>
                    <div className="curved-table-content">
                        {!loading && !tableRows.length ? (
                            <NoFoliosFound info={`${dashboard.UpdateForm15.EmptyNomineeInfo}`} />
                        ) : (
                            <TableWithCollapse
                                rows={tableRows}
                                columns={tableColumns}
                                checkBoxEnabled
                                isRowSelectable={(params) => (params.row.isDisabled ? false : true)}
                                resetFilters={resetFilters}
                                {...rest}
                            />
                        )}
                    </div>
                    <FaqLink section={FORM_15GH} history={props.history} />
                </div>
                <div className="curved-bg-content-inner-bottom">
                    {/* <FormControlLabel
                        control={<Checkbox />}
                        label={dashboard.UpdateForm15.agreeTerms}
                    />*/}
                    <div className="table-submit">
                        <Button
                            // href="/portal/nct/update-form15-income"
                            onClick={() => setCallPanSeed(true)}
                            className="customBtn"
                            disabled={!rest.selectedRows.length}
                        >
                            {dashboard.UpdateForm15.submit}
                        </Button>
                    </div>
                </div>
            </div>
            <Dialog maxWidth={'md'} open={false} aria-labelledby="form15-not-applicable-modal">
                <div className="form15-not-applicable-modal">
                    <img src="/images/error-red.svg" alt="icon" />
                    <p>{dashboard.UpdateForm15.listModalInfo}</p>
                    <ul>
                        <li>
                            1. ICICI Prudential Regular Savings Fund Direct-IDCW Monthly Payout -
                            20056123400
                        </li>
                    </ul>
                    <div className="buttons">
                        <Button className="customBtn">{dashboard.UpdateForm15.okayBtn}</Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}

export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), { getForm15Info })(
    UpdateForm15List,
);
